import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Globe, MessageCircle, Send, Music2, Facebook, Twitter, Rss, Instagram, Youtube, Phone } from "lucide-react";
import { getFooter } from "../../api";

const ICONS = { discord: MessageCircle, telegram: Send, tiktok: Music2, facebook: Facebook, "x-twitter": Twitter, reddit: Rss, instagram: Instagram, youtube: Youtube, whatsapp: Phone };
const NAMES = { discord: "Discord", telegram: "Telegram", tiktok: "TikTok", facebook: "Facebook", "x-twitter": "X.com", reddit: "Reddit", instagram: "Instagram", youtube: "YouTube", whatsapp: "WhatsApp" };
const live = (h) => h && h !== "#";

const FLink = ({ l }) => (l.href || "").startsWith("/")
  ? <Link to={l.href}>{l.label}</Link>
  : <a href={l.href || "#"} {...(live(l.href) ? { target: "_blank", rel: "noreferrer" } : {})}>{l.label}</a>;

const Store = ({ href, small, big, id }) => (
  <a className={`az-fstore${href ? "" : " soon"}`} href={href || undefined} target="_blank" rel="noreferrer" data-testid={`az-footer-store-${id}`}>
    <small>{href ? small : "Coming soon"}</small><b>{big}</b>
  </a>
);

export const AzFooter = ({ apps, contact }) => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { getFooter().then(setCfg).catch(() => setCfg({})); }, []);
  const socials = (cfg?.socials || []).filter((s) => live(s.href));
  return (
    <footer className="az-wrap az-footer" data-testid="az-footer">
      <div className="az-footer-top">
        <div className="az-footer-brand">
          <img src="/assets/imperio-logo.png" alt="Imperio Exchange" />
          <div className="az-footer-mails">
            <span><small>Partnership/Offers</small><a href={`mailto:${contact?.marketing}`} data-testid="az-footer-marketing">{contact?.marketing}</a></span>
            <span><small>Customer Service</small><a href={`mailto:${contact?.support}`} data-testid="az-footer-support">{contact?.support}</a></span>
          </div>
          <p>Imperio is a new generation exchange offering spot trading, USDT-M futures, earn products and instant convert. 24/7 support. We work best to be the first.</p>
          <small className="az-footer-label">Imperio on mobile</small>
          <div className="az-footer-stores">
            <Store href={apps?.ios} small="Download on the" big="App Store" id="ios" />
            <Store href={apps?.android} small="Get it on" big="Google Play" id="android" />
          </div>
        </div>
        <div className="az-footer-cols">
          {(cfg?.columns || []).map((c, i) => (
            <div key={i} className="az-footer-col" data-testid={`az-footer-col-${i}`}>
              <small>{c.title}</small>
              {(c.links || []).map((l, j) => <FLink key={j} l={l} />)}
            </div>
          ))}
        </div>
      </div>
      <div className="az-footer-legal">
        <p>DISCLAIMER: Derivatives are complex instruments and come with a higher risk of losing money rapidly due to leverage. You should always consider and do your own research whether you understand how derivatives and futures markets operate and whether you can afford to take the higher risk of losing your funds.</p>
        <p>Crypto asset prices are volatile. Past performance is not a guide to future results. Imperio may not offer some or all of its services to residents of certain jurisdictions.</p>
      </div>
      <div className="az-footer-bottom">
        <div className="az-footer-socials">
          {socials.map((s, i) => { const Ic = ICONS[s.icon] || Globe; return <a key={i} href={s.href} target="_blank" rel="noreferrer" data-testid={`az-footer-social-${s.icon}`}><Ic size={16} /> {NAMES[s.icon] || s.icon}</a>; })}
        </div>
        <span data-testid="az-footer-copyright">{cfg?.copyright || `Imperio © ${new Date().getFullYear()}`}</span>
      </div>
    </footer>
  );
};
